/* Shopify performs filtering and sorting across the collection before pagination. */
(function () {
  'use strict';
  function init() {
    var root = document.getElementById('aona-plp-root');
    if (!root || root.dataset.nativeCollectionReady) return;
    root.dataset.nativeCollectionReady = 'true';
    var sidebar = root.querySelector('#aona-filter-sidebar');
    var filterForm = root.querySelector('#aona-collection-filter-form');
    var sortForm = root.querySelector('#aona-collection-sort-form');
    var sortSelect = root.querySelector('#aona-sort-by-select');

    function navigate(url) { window.location.assign(url.toString()); }
    function sortCollection(event) {
      if (event) event.preventDefault();
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      navigate(url);
    }
    if (sortSelect) sortSelect.addEventListener('change', sortCollection);
    if (sortForm) sortForm.addEventListener('submit', sortCollection);
    if (filterForm) {
      var minInput = filterForm.querySelector('[data-price-min]');
      var maxInput = filterForm.querySelector('[data-price-max]');
      function validatePrice() {
        if (!minInput || !maxInput) return;
        var invalid = minInput.value !== '' && maxInput.value !== '' && Number(minInput.value) > Number(maxInput.value);
        maxInput.setCustomValidity(invalid ? 'Maximum price must be at least the minimum price.' : '');
      }
      if (minInput) minInput.addEventListener('input', validatePrice);
      if (maxInput) maxInput.addEventListener('input', validatePrice);
      filterForm.addEventListener('submit', function (event) {
        event.preventDefault();
        validatePrice();
        if (!filterForm.reportValidity()) return;
        var url = new URL(window.location.href);
        // Remove all represented names, including unchecked or disabled values.
        Array.from(filterForm.elements).forEach(function (input) {
          if (input.name) url.searchParams.delete(input.name);
        });
        new FormData(filterForm).forEach(function (value, name) {
          if (value !== '') url.searchParams.append(name, value);
        });
        url.searchParams.delete('page');
        navigate(url);
      });
    }
    var clear = root.querySelector('#aona-clear-all-filters');
    if (clear) clear.addEventListener('click', function (event) {
      event.preventDefault();
      var url = new URL(window.location.href);
      Array.from(url.searchParams.keys()).forEach(function (key) {
        if (key.indexOf('filter.') === 0 || key === 'page') url.searchParams.delete(key);
      });
      navigate(url);
    });

    var openButton = root.querySelector('#aona-mobile-filter-open');
    var closeButton = root.querySelector('#aona-mobile-filter-close');
    var overlay = root.querySelector('#aona-mobile-filter-overlay');
    var mobile = window.matchMedia('(max-width: 900px)');
    var previousFocus, previousOverflow, inerted = [];
    function focusables() {
      return Array.from(sidebar.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex="0"]')).filter(function (el) {
        return el.getClientRects().length > 0;
      });
    }
    function closeDrawer(restoreFocus) {
      if (!sidebar || !sidebar.classList.contains('mobile-open')) return;
      sidebar.classList.remove('mobile-open');
      overlay.classList.remove('mobile-open');
      sidebar.removeAttribute('role');
      sidebar.removeAttribute('aria-modal');
      openButton.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = previousOverflow;
      inerted.forEach(function (entry) { entry[0].inert = entry[1]; });
      inerted = [];
      if (restoreFocus !== false && previousFocus && previousFocus.isConnected) previousFocus.focus();
    }
    function openDrawer() {
      if (!mobile.matches || !sidebar || sidebar.classList.contains('mobile-open')) return;
      previousFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      sidebar.classList.add('mobile-open');
      overlay.classList.add('mobile-open');
      sidebar.setAttribute('role', 'dialog');
      sidebar.setAttribute('aria-modal', 'true');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      // Isolate sibling branches up to body, while leaving the overlay clickable.
      var node = sidebar;
      while (node.parentElement && node !== document.body) {
        Array.from(node.parentElement.children).forEach(function (sibling) {
          if (sibling !== node && sibling !== overlay && sibling.tagName !== 'SCRIPT' && sibling.tagName !== 'STYLE') {
            inerted.push([sibling, sibling.inert]);
            sibling.inert = true;
          }
        });
        node = node.parentElement;
      }
      (focusables()[0] || sidebar).focus();
    }
    if (openButton && closeButton && overlay && sidebar) {
      openButton.addEventListener('click', openDrawer);
      closeButton.addEventListener('click', function () { closeDrawer(); });
      overlay.addEventListener('click', function () { closeDrawer(); });
      document.addEventListener('keydown', function (event) {
        if (!sidebar.classList.contains('mobile-open')) return;
        if (event.key === 'Escape') { event.preventDefault(); closeDrawer(); return; }
        if (event.key !== 'Tab') return;
        var items = focusables();
        var first = items[0], last = items[items.length - 1];
        if (!first) { event.preventDefault(); sidebar.focus(); }
        else if (event.shiftKey && (document.activeElement === first || !sidebar.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || !sidebar.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
      });
      mobile.addEventListener('change', function () { if (!mobile.matches) closeDrawer(false); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
